import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from '../../cfg/cfg.service';

export class HeaderCfg {
  public versionCheckTime: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderCfgService extends CfgService<HeaderCfg> {
  protected exclude: boolean = true;

  constructor(httpBackend: HttpBackend) {
    super(httpBackend);
  }

  public async initialize(): Promise<void> {
    await super.initialize();
  }

  protected getCfgFile(): string {
    return `/cfg/header.cfg.json`;
  }
}
